export interface Application {
  applicationID: string;
  applicantType: string;
  applicationNumber: string;
  dateReceived: string;
  roadOpeningLocation: string;
  applicantName: string;
  workDate: string;
  status: string;
  lastActivityDate: string;
}

export type PaymentSummary = {
  fees: {
    [key: string]: number; // This will hold dynamic fee names and amounts
  };
  taxRate?: number;
};

export type PaymentApplicationDetails = {
  applicationDetails: {
    [key: string]: number | string | null; // This will hold dynamic fee names and amounts
  };
};

export enum PermitFeeType {
  ApplicationFee = 'Road Opening Permit Fee',
  InspectionFee = 'Road Opening Inspection Fee',
  AdditionalInspectionFee = 'Road Opening Additional Inspection Fee',
  CCTaxRate = 'Credit Card Tax Rate'
}

export enum PermitFeeTypeName {
  ApplicationFee = 'Application Fee',
  InspectionFee = 'Inspection Fee',
  AdditionalInspectionFee = 'Road Opening Additional Inspection Fee',
  CreditCardFee = 'Credit Card Fee',
  ApplicationFeeNonSpayed = 'Application Fee Non Spayed/Neutered',
  ApplicationFeeSpayed = 'Application Fee Spayed/Neutered',
  PilotClinicFeePet = 'Pilot Clinic Fee',
  StateRegistrationFeePet = 'State Registration Fee',
  LateMonthlyFee = 'Late Monthly Fee',
  DelinquencyFee = 'Delinquency Fee'
}

export const feeTypes = [
  { FeeTypeID: 1, FeeTypeName: 'Application Fee' },
  { FeeTypeID: 2, FeeTypeName: 'Inspection Fee' },
  { FeeTypeID: 3, FeeTypeName: 'Credit Card Fee' }
];
